import type { CSSProperties, InputHTMLAttributes, Ref } from 'react';
import { COMMON } from '@locales/id/messages';
import { Button } from './Button';
import { Icon } from './Icon';

/** Search box with an icon; `label` is read by screen readers; `ref` reaches the input. */
export function SearchInput({ label, style, inputStyle, ...input }: { label: string; style?: CSSProperties; inputStyle?: CSSProperties; ref?: Ref<HTMLInputElement> } & InputHTMLAttributes<HTMLInputElement>) {
  return (
    <label className="search" style={style}>
      <span className="sr-only">{label}</span>
      <Icon name="search" size={18} />
      <input type="search" style={inputStyle} {...input} />
    </label>
  );
}

export function ClearFiltersButton({ onClick, ghost }: { onClick: () => void; ghost?: boolean }) {
  return (
    <Button variant={ghost ? 'ghost' : undefined} onClick={onClick}>
      {COMMON.clearFilters}
    </Button>
  );
}
